import { computed, inject, Injectable, signal } from '@angular/core'
import { User } from '../interfaces/participant.interface'
import { UsersService } from '../services/users/users.service'
import { MonthOption, UserWithKpis } from '../interfaces/kpis.interface'
import { KpisService } from '../services/kpis/kpis.service'

@Injectable({
  providedIn: 'root'
})
export class Store {
  usersService = inject(UsersService)
  kpisService = inject(KpisService)

  #currentUser = signal<User | null>(null)
  currentUser = this.#currentUser.asReadonly()

  isAuthenticated = computed(() => !!this.#currentUser())

  #currentMonth = signal<MonthOption>({ value: '', label: '' })
  currentMonth = this.#currentMonth.asReadonly()

  #monthsOptions = signal<MonthOption[]>([])
  monthsOptions = this.#monthsOptions.asReadonly()

  #userWithKpis = signal<UserWithKpis | null>(null)
  userWithKpis = this.#userWithKpis.asReadonly()

  constructor() {
    const monthsOptions = this.getMonthsOptions(2)
    // const monthsOptions = [{ value: 'enero_2025', label: 'Enero 2025' }]

    this.#currentMonth.set(monthsOptions[0])
    this.#monthsOptions.set(monthsOptions)
  }

  months = signal([
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre'
  ])

  setUser(user: User | null) {
    this.#currentUser.set(user)
  }

  async getKpis(user: User) {
    const existing = this.#userWithKpis()
    const month = this.#currentMonth().value
    if (existing) return existing

    const data = await this.kpisService.getCurrentUserGeneralKpis(user, month)
    this.#userWithKpis.set(data)
    return data
  }

  private getMonthsOptions(monthsToShow = 2): MonthOption[] {
    const date = new Date()
    const day = date.getDate()

    const options: MonthOption[] = []
    const startOffset = day <= 5 ? 1 : 0

    for (let i = 0; i < monthsToShow; i++) {
      const targetDate = new Date(date)
      targetDate.setMonth(date.getMonth() - startOffset - i)

      const monthNumber = targetDate.getMonth()
      const year = targetDate.getFullYear()
      const monthName = this.months()[monthNumber]

      options.push({
        value: `${monthName}_${year}`,
        label: `${monthName.charAt(0).toUpperCase() + monthName.slice(1)} ${year}`
      })
    }

    return options
  }
}
